var _g, _tspan, _tspan2, _tspan3, _tspan4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStakLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 59,
    viewBox: "0 0 150 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Stak Logo"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "center",
    d: "M24.1641 28.3356V17.8679",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightMid",
    d: "M35.1328 36.1864V10.0171",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right",
    d: "M46.1013 44.0372V2.16638",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "leftMid",
    d: "M13.1953 10.0171V36.1864",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left",
    d: "M2.22656 2.16638V44.0372",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "STAK Temp Logo"
  }, /*#__PURE__*/React.createElement("text", {
    id: "s",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Open Sans",
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    y: 32.3439
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    id: "t",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Open Sans",
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 88.1494,
    y: 32.3439
  }, "t"))), /*#__PURE__*/React.createElement("text", {
    id: "a",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Open Sans",
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 105.636,
    y: 32.3439
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    id: "k",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Open Sans",
    fontSize: 28,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 128.951,
    y: 32.3439
  }, "k"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakLogo);
export default __webpack_public_path__ + "static/media/Stak Logo.9bc8a59960759fcc0da5f7af2f677f3f.svg";
export { ForwardRef as ReactComponent };